module.exports = __webpack_public_path__ + "img/left_md_5.936f905f.jpg";